/**
 * L3 — Text Left / Visual Right (mirror of L2)
 * Left 45%: headline + subheadline
 * Right 55%: primary image/video
 */
import React from 'react';
import { AbsoluteFill } from 'remotion';
import type { SceneProps } from '../../types';
import {
  SceneContainer, Visual, HeadlineText, SubheadlineText,
  GlobalOverlays, AccentBar,
} from './shared';

export const L3_TextLeftVisualRight: React.FC<SceneProps> = (props) => {
  const { headline, subheadline, assets, colorPalette, headlineFont, subheadlineFont } = props;
  const primary = assets.primary ?? assets.video;

  return (
    <SceneContainer bg={colorPalette.background}>
      <AbsoluteFill style={{ display: 'flex', flexDirection: 'row' }}>

        {/* Left: text panel */}
        <div style={{
          width: '45%', height: '100%',
          background: colorPalette.background,
          display: 'flex', flexDirection: 'column',
          justifyContent: 'center',
          padding: '60px 40px 100px 80px',
          boxSizing: 'border-box',
        }}>
          <AccentBar color={colorPalette.accent} style={{ marginBottom: 20, width: 60 }} />

          <HeadlineText
            text={headline}
            font={{ ...headlineFont, fontSize: Math.min(headlineFont.fontSize, 48) }}
            delay={6}
            layerKey="headline"
          />

          {subheadline && (
            <SubheadlineText
              text={subheadline}
              font={subheadlineFont}
              delay={18}
              style={{ marginTop: 16 }}
              layerKey="subheadline"
            />
          )}
        </div>

        {/* Right: visual */}
        <div style={{ width: '55%', height: '100%', overflow: 'hidden', position: 'relative' }}>
          {/* Left-edge gradient */}
          <div style={{
            position: 'absolute', top: 0, left: 0, width: 80, height: '100%', zIndex: 1,
            background: `linear-gradient(to left, transparent, ${colorPalette.background})`,
          }} />
          <Visual asset={primary} kenBurns kenBurnsDirection="in" layerKey="primaryMedia" />
        </div>
      </AbsoluteFill>

      <GlobalOverlays props={props} />
    </SceneContainer>
  );
};
